import Img from 'components/common/Img'
import { MEDIA_URL } from 'config/constants'
import formatMoney from 'lib/formatMoney'
import { IProduct } from 'store/api'
import {
  isNonEmptyArray,
  isNonEmptyObj,
  isNonEmptyString,
  isPresent,
  toValues,
} from 'lib/utils'
import { useMemo } from 'react'

const HeaderSearchItem = ({ item }: { item: IProduct }) => {
  const { price, name, image, short_desc, typeMeta, weight } = item
  const variationInfo = useMemo(() => {
    if (isNonEmptyObj(typeMeta?.attributes)) {
      const attrs = toValues(typeMeta?.attributes)
      const info = isNonEmptyArray(attrs)
        ? attrs[0]['name']
        : undefined
      return info
    }
    return undefined
  }, [typeMeta])
  const weightIsPresent = isNonEmptyString(weight) && weight !== '0'

  return (
    <div className='flex h-max w-full justify-between items-start bg-white'>
      <div className='w-20 h-20 relative flex-shrink-0 overflow-hidden rounded-lg'>
        <Img
          src={`${MEDIA_URL}${image}`}
          alt={name}
          layout='fill'
          objectFit='cover'
        />
      </div>

      <div className='ml-4 gap-y-1 w-full flex flex-col'>
        <div className='flex gap-y-1 flex-col'>
          <span className='font-bold text-base mb-2'>{name}</span>

          <div className='text-xs text-bodyGrey leading-tight line-clamp-2'>
            {short_desc}
          </div>
          <div className='flex gap-x-1 flex-row items-center text-xs text-darkblue'>
            <span>
              {isPresent(variationInfo)
                ? `${variationInfo} ${weightIsPresent ? '·' : ''} `
                : ''}
              {weightIsPresent ? `${weight} г ·` : '·'}
            </span>
            <span className='text-xs font-bold md:text-right bg-primary rounded p-1 w-max'>
              {formatMoney(price)}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HeaderSearchItem
